export enum CoreEventEmitter {
	CANVAS = 'canvas',
	DOCUMENT = 'document',
}
export const EVENT_EMITTERS: CoreEventEmitter[] = [CoreEventEmitter.CANVAS, CoreEventEmitter.DOCUMENT];
